import { useEffect } from 'react'
import styled from 'styled-components'
import Lottie from 'react-lottie-player'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { pipe, map, prop, includes, anyPass } from 'ramda'
import { select } from '@/store'
import { colors } from '@/styles'
import { createModal, useModalize } from '@/components/modalize/mui'
import animationData from '@/components/loading/loading.json'

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100px;
  width: 100px;
`

const lottieOptions = {
  loop: true,
  play: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 24px;
`

const Title = styled.h5`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
`

const Paragraph = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.grey48};
  margin: 8px 0 24px;
`
const isUploading = anyPass([includes('pending'), includes('in_progress')])

const UploadingModal = ({ contractId }) => {
  const { t } = useTranslation()
  const { close } = useModalize()
  const { packageFiles = [] } = useSelector(state =>
    select.contract.contractPackageInfo(state, { contractId: contractId })
  )

  const uploadStatuses = pipe(map(prop('upload_status')))(packageFiles)
  const hasUploading = isUploading(uploadStatuses)

  useEffect(() => {
    if (!hasUploading) close()
  }, [hasUploading])

  return (
    <Container>
      <TextWrapper>
        <LoadingWrapper>
          <Lottie {...lottieOptions} style={{ height: 100, width: 100 }} />
        </LoadingWrapper>
        <Title>{t('l.uploading_modal.title.text', 'Your files are still uploading...')}</Title>
        <Paragraph>
          {t('l.uploading_modal.content.text', 'This may take up to several minutes.')}
        </Paragraph>
      </TextWrapper>
    </Container>
  )
}

const showUploadingModal = createModal(UploadingModal, { showClose: true, width: '580px' })

export default showUploadingModal
